<template>
  <div id="index">
    <Advertisement
      v-if="banners.length > 0"
      :allCar="allCar"
      :bestCar="bestCar"
      :bannerImages="banners"
    ></Advertisement>
    <!-- <depositUp v-if="showItems.length > 0" :data="itemObj" /> -->
    <CarList v-if="showItems.length > 0" :showItems="showItems"></CarList>
    <ZeroBuy v-if="zeroBuyShow" :id="carId" :activityId="activityId" @close="closeZeroBuy"></ZeroBuy>
  </div>
</template>

<script>
import Advertisement from '@/components/business/mall/advertisement.vue'
import CarList from '@/components/business/mall/carList.vue'
import ZeroBuy from '@/components/business/mall/zeroBuyBox.vue'
import depositUp from '@/components/business/activity/depositUp.vue'
import { setStorage, getStorage } from '@/lib/utils'
// import { Button } from 'element-ui';
import homeApi from '@/api/home.js'
import personcenterApi from '@/api/personcenter'
export default {
  name: 'mall',
  data() {
    const activity = this.$route.query.activity
    const activityId = this.$route.query.activityId
    const carId = this.$route.query.id
    return {
      testList: {},
      allCar: [],
      bestCar: [],
      banners: [], // 轮播图
      showItems: [],
      activity,
      carId,
      activityId,
      zeroBuyShow: activity === 'zeroBuy' && carId && activityId,
      itemObj: {}
    }
  },
  props: {},
  watch: {},
  mounted() {},
  /* eslint-disable */
  methods: {
    closeZeroBuy() {
      this.zeroBuyShow = false
    },
    init() {
      // 首页轮播和楼层
      const data = {
        displayPlatform: 1,
        positionType: 1,
        vmId: 1
      }
      homeApi.homePage(data).then((res) => {
        if (res.status === 200) {
          if (res.data.showItems) {
            this.showItems = res.data.showItems
            res.data.showItems.map((e) => {
              if (e.code === 'Deposit') {
                this.itemObj = e
              }
            })
          }
          if (res.data.banners) {
            this.banners = res.data.banners
          }
        }
      })
      // 全线车系侧边栏
      homeApi.allCarListAsider({ code: 'mall-car', vmId: 1 }).then((res) => {
        if (res.status === 200) {
          this.allCar = res.data
        }
      })
      // 奇瑞精选侧边栏
      homeApi
        .bestCarListAsider({
          code: 'mall-jp',
          vmId: 1
        })
        .then((res) => {
          if (res.status === 200) {
            this.bestCar = res.data
          }
        })
    }
  },
  created() {
    const isLogin = !!getStorage('accessToken')
    window.Countly.q.push([
      'add_event',
      {
        key: 'pc#home',
        segmentation: {
          ea: '浏览首页',
          ds_: 'web',
          tid: 10,
          dl_: window.location.href,
          host: window.location.host,
          utt: window.localStorage.getItem('windowStartTime')
                ? new Date().getTime() - window.localStorage.getItem('windowStartTime')
                : 0,
          media: 100012,
          uid: getStorage('userInfo') && getStorage('userInfo').accountId
        }
      }
    ]
    )
    window.localStorage.setItem('windowStartTime', new Date().getTime())
    if (isLogin) {
      personcenterApi
        .getUserInfo()
        .then((res) => {
          if (res.status === 200) {
            const { account } = res.data
            setStorage('agentId', account.id)
            this.init()
          } else {
            this.init()
          }
        })
        .catch((err) => {
          this.init()
        })
    } else {
      this.init()
    }
  },
  components: {
    // "ElButton" : Button
    Advertisement,
    CarList,
    ZeroBuy,
    depositUp
  }
}
</script>
<style lang="scss" scoped>
.transaction-page {
  width: 100%;
  height: 100%;
  background: rgba(245, 245, 245, 0.3);
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 999;
}
.QR-Code {
  width: 400px;
  height: 448px;
  position: absolute;
  top: 100px;
  left: 50%;
  margin-left: -200px;
  background-color: white;
  z-index: 10000;
}
.QR-Code p {
  text-align: center;
}
.QR-title {
  width: 225px;
  margin: 42px auto 26px;
  // background-color: lightcoral;
}
.QR-title > span {
  display: inline-block;
  width: 104px;
  height: 37px;
  font-size: 26px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  background-clip: text;
  -webkit-background-clip: text;
  background-color: red;
}
.QR-title > img {
  width: 101px;
  height: 27px;
  margin-left: 15px;
  vertical-align: bottom;
}
.QR-img {
  width: 220px;
  height: 220px;
  margin: 26px auto 40px;
  img {
    width: 100%;
  }
}
</style>
